import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class OpenQuestionProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.Text) public question?: Types["Text"];

  @Inlet(Accepts.Void) public logic?: Types["Void"];

  @Inlet(Accepts.Boolean) public isRequired?: Types["Boolean"];

  @Inlet(Accepts.String) public placeholder?: Types["String"];
}

export const OpenQuestionDefinition = defineElement(
  "open-question",
  OpenQuestionProps,
  {
    versionRequired: "0.9.0",
    outputs: [{ key: "default", label: "User answer" }],
  }
);
